import { render, staticRenderFns } from "./JdsMeridianItem.vue?vue&type=template&id=31b241f8&scoped=true&"
import script from "./JdsMeridianItem.vue?vue&type=script&lang=ts&"
export * from "./JdsMeridianItem.vue?vue&type=script&lang=ts&"
import style0 from "./JdsMeridianItem.vue?vue&type=style&index=0&id=31b241f8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b241f8",
  null
  
)

export default component.exports